export default __webpack_public_path__ + "static/media/197-melilla.44ac1405.svg";